<!--校园安全视频管理-->
<template>
    <div class="app-container">
        <div class="rqzj-manager-container">
            <!--目录-->
            <div class="l-container">
                <div class="l-top-container">
                    <div class="l-box">目录</div>
                    <div class="r-box cursor">
                        <div style="margin-top: 4px;">
                        </div>
                        <div style="text-indent: 2px;">
                            <el-button type="primary" size="small" @click="handleTopCreate">
                                +目录
                            </el-button>
                        </div>
                    </div>
                </div>
                <el-scrollbar class="rqzj-l-tree-container">
                    <el-tree
                      class="custom-tree"
                      :data="catalogList"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-click="handleNodeClick">
                        <template #default="{ data }">
                            <div class="custom-tree-node" :title="charConversion(data.catalogName)">
                                <div class="tree-l">
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.catalogName)}}</span>
                                </div>
                                <div class="tree-r">
                                    <el-icon class="cursor mr5" title="新增目录" @click.stop="handleSonCreate(data)">
                                        <Plus />
                                    </el-icon>
                                    <el-icon class="cursor mr5" title="编辑目录" @click.stop="handleUpdate(data)">
                                        <Edit />
                                    </el-icon>
                                    <el-popconfirm confirm-button-text="是"
                                                   cancel-button-text="否"
                                                   icon-color="#626AEF" title="确定删除该目录"
                                                   @confirm="handleDeleteCatalog(data.catalogId)">
                                        <template #reference>
                                            <el-icon class="cursor mr5" title="删除目录">
                                                <Delete />
                                            </el-icon>
                                        </template>
                                    </el-popconfirm>
                                    <el-icon class="cursor mr5" title="上传视频" @click.stop="handleVideoUpload(data)">
                                        <Folder />
                                    </el-icon>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <!--视频列表-->
            <div class="r-container">
                <div class="form-box">
                    <el-form :inline="true"
                             label-width="90px">
                        <el-row>
                            <el-col :span="2">
                                <svg t="1775018007241" class="icon cursor" @click="resetSearch" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8064" width="30" height="30"><path d="M512 57.677643C261.084506 57.677643 57.677643 261.084506 57.677643 512s203.406863 454.322357 454.322357 454.322357 454.322357-203.406863 454.322357-454.322357S762.915494 57.677643 512 57.677643z" fill="#0d55a4" p-id="8065" data-spm-anchor-id="a313x.search_index.0.i11.35603a81rpIomP" class="selected"></path><path d="M581.060548 231.577511c-41.567834-41.568721-84.297206-66.239667-95.428104-55.108769-11.137997 11.137109 13.540936 53.86027 55.108769 95.428991a399.812548 399.812548 0 0 0 3.868839 3.816485c-18.446198-2.465941-38.703473-3.828908-59.958128-3.828908-77.080402 0-141.021837 17.917338-153.042745 41.397463-17.152444 22.420631-29.056222 71.617886-29.056222 128.705442 0 78.219757 22.352305 141.629671 49.931092 141.629671 27.578787 0 49.939965-63.409913 49.939965-141.629671 0-29.986163-3.285851-57.794773-8.891231-80.689248 25.579591 5.930149 57.067147 9.428076 91.118253 9.428076 22.752499 0 44.362094-1.561733 63.828742-4.367528a399.907494 399.907494 0 0 0-7.739452 7.534475c-41.568721 41.568721-66.240555 84.298094-55.109657 95.428991 11.137109 11.137109 53.86027-13.540049 95.428991-55.10877 34.770745-34.770745 57.718461-70.344541 57.776139-87.567972a16.620035 16.620035 0 0 0 0.897109-5.344499c0-2.19175-0.448111-4.351556-1.316825-6.468769-3.259231-18.402718-25.271681-51.17338-57.355535-83.25546z m40.5181 350.441373c0 29.983501 3.284076 57.788562 8.887681 80.682149-25.582253-5.927487-57.071584-9.425414-91.124464-9.425414-22.751612 0-44.360319 1.561733-63.825193 4.365754a405.916617 405.916617 0 0 0 7.747439-7.542461c41.568721-41.568721 66.240555-84.285671 55.102558-95.42278-11.130898-11.130898-53.853172 13.533837-95.42278 55.102558-34.768971 34.768971-57.715799 70.348977-57.779688 87.573296a16.628908 16.628908 0 0 0-0.894447 5.340063c0 2.184652 0.444562 4.337359 1.307064 6.447473 3.242371 18.400055 25.269019 51.187577 57.367958 83.287403 41.568721 41.567834 84.285671 66.240555 95.42278 55.102559 11.130898-11.130898-13.533837-53.853172-55.102558-95.42278a410.577858 410.577858 0 0 0-3.868839-3.81826c18.440873 2.466828 38.693712 3.828908 59.945706 3.828908 77.092825 0 141.048458-17.930648 153.056943-41.416985 17.148007-22.42773 29.051785-71.612562 29.051785-128.681483 0-78.228631-22.361179-141.638544-49.939966-141.638544-27.578787 0-49.931092 63.409913-49.931091 141.638544z" fill="#FFFFFF" p-id="8066"></path></svg>
                            </el-col>
                            <el-col :span="22">
                                <el-form-item class="pull-right">
                                    <el-input v-model="queryVideoForm.videoTitle" placeholder="请输入视频名称" class="input-with-select"
                                              clearable @clear="queryVideoList">
                                        <template #append>
                                            <el-button type="primary" @click="queryVideoList" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="bre9e mt5">
                <div class="video-card-container" v-loading="loading">
                    <el-empty v-if="!loading && dataList.length == 0" description="暂无数据" />
                    <div v-for="(item, index) in dataList" :key="index" class="video-card">
                        <img v-if="item.videoCover" class="video-card-cover cursor"
                             :src="item.videoCover"
                             @click="handlePlay(item)" />
                        <video v-else class="video-card-cover cursor"
                               :src="item.videoUrl + '#t=0.1'"
                               preload="metadata"
                               @click="handlePlay(item)"></video>
                        <div class="video-card-del">
                            <el-popconfirm confirm-button-text="是"
                                           cancel-button-text="否"
                                           icon-color="#626AEF" title="确定删除视频"
                                           @confirm="handleDeleteVideo(item)">
                                <template #reference>
                                    <el-icon class="cursor" title="删除视频" @click.stop>
                                        <Delete />
                                    </el-icon>
                                </template>
                            </el-popconfirm>
                        </div>
                        <div class="video-card-name" :title="item.videoTitle">{{ item.videoTitle }}</div>
                        <div class="video-card-speaker" :title="item.videoSpeaker">
                            {{ item.videoSpeaker }}<span v-if="item.videoSpeakerOrg">（{{ item.videoSpeakerOrg }}）</span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog width="530px" :title="dialogTitle" v-model="isShowCatalogDialog">
        <div>
            <el-form>
                <el-input v-model="catalogForm.catalogName" placeholder="请输入目录名称"/>
            </el-form>
        </div>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitCatalog">
                    确定
                </el-button>
                <el-button @click="isShowCatalogDialog = !isShowCatalogDialog">
                    取消
                </el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog width="530px" :title="dialogTitle" v-model="isShowCatalogUpdateDialog">
        <div>
            <el-form>
                <el-input v-model="catalogForm.catalogName" placeholder="请输入目录名称"/>
            </el-form>
        </div>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitUpdateCatalog">
                    确定
                </el-button>
                <el-button @click="isShowCatalogUpdateDialog = !isShowCatalogUpdateDialog">
                    取消
                </el-button>
            </div>
        </template>
    </el-dialog>

    <!--上传视频-->
    <el-dialog title="上传视频" v-model="isShowVideoDialog" width="35%" @close="resetVideoForm">
        <el-row>
            <el-col :span="24">
                <el-form-item label="视频名称" label-width="100px">
                    <el-input v-model="videoForm.videoTitle" placeholder="请输入视频名称"/>
                </el-form-item>
                <el-form-item label="主讲人" label-width="100px">
                    <el-input v-model="videoForm.videoSpeaker" placeholder="请输入主讲人"/>
                </el-form-item>
                <el-form-item label="所属单位" label-width="100px">
                    <el-input v-model="videoForm.videoSpeakerOrg" placeholder="请输入主讲人所属单位"/>
                </el-form-item>
                <el-form-item label="上传视频" label-width="100px">
                    <el-upload class="upload-demo"
                               ref="upload"
                               :limit="1"
                               v-model:file-list="videoFileList"
                               accept=".mp4,.flv,.wmv"
                               :http-request="handleUploadRequest"
                               :on-remove="handleVideoRemove"
                               :before-upload="beforeVideoUpload">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                只允许上传.mp4,.flv,.wmv格式文件，大小不超过2G。
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>

        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" :loading="uploadLoading" @click="submitVideo">确定</el-button>
                <el-button @click="isShowVideoDialog=!isShowVideoDialog">取消</el-button>
            </div>
        </template>
    </el-dialog>

    <!--视频播放-->
    <el-dialog v-model="isShowPlayDialog" width="76%" top="50px" @close="playUrl = ''">
        <video v-if="playUrl" :src="playUrl" controls autoplay
               style="width: 100%;max-height:calc(100vh - 250px)"></video>
    </el-dialog>

    <div class="loading-overlay" v-if="loadingVisible">
        <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="8"></el-progress>
        <p class="tips_css">上传中，请等待...</p>
    </div>
</template>
<script>
let OSS = require('ali-oss');
let client = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAI5tCqpy6gH2Kfn5F7mS7H',
    accessKeySecret: 'aVdDcMLLrcWYW5WBePRglyd3oqNIF1',
    bucket: 'free-back'
})
/*分片大小*/
const SHARD_SIZE_CONFIG = {
    SMALL: 1, // < 200MB
    MEDIUM: 2, // < 1024MB
    LARGE: 5, // < 2048MB
    X_LARGE_RATIO: 500 // >= 2048MB
};
import {charConversion} from "@/utils/str"
import {getFileNameUUID, signatureUrl} from "@/utils/tools";
import {createVideoCatalog, updateVideoCatalog, treeVideoCatalog, deleteVideoCatalog} from "@/api/admin/videoCatalog"
import {createVideo, updateVideo, listVideo, deleteVideo} from "@/api/admin/video"

export default {
    name: "schoolSafeVideoManager",
    components: {},
    data() {
        return {
            charConversion,
            loading: false,
            isShowCatalogDialog: false,
            isShowCatalogUpdateDialog: false,
            isShowVideoDialog: false,
            isShowPlayDialog: false,
            uploadLoading: false,
            loadingVisible: false,
            loadingPercentage: 0,
            partItemSize: 5,
            dialogTitle: '',
            catalogList: [],
            catalogForm: {
                catalogId: '',
                catalogProfile: '1',
                parentId: '',
                catalogName: '',
            },
            queryCatalogForm: {
                catalogProfile: '1',
            },
            // 查询视频
            queryVideoForm: {
                catalogId: '',
                videoType: '1',
                videoTitle: '',
            },
            dataList: [],
            // 上传视频
            videoFileList: [],
            videoForm: {
                catalogId: '',
                videoType: '1',
                videoTitle: '',
                videoUrl: '',
                videoCover: '',
                videoSpeaker: '',
                videoSpeakerOrg: '',
            },
            // 视频播放
            playUrl: '',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryTreeCatalog();
        this.queryVideoList();
    },
    mounted() {},
    methods: {
        handleNodeClick(e, i) {
            this.queryVideoForm.catalogId = e.catalogId;
            this.queryVideoList();
        },
        //新增父级节点
        handleTopCreate() {
            this.dialogTitle = '新建目录'
            this.catalogForm.parentId = '0';
            this.isShowCatalogDialog = true;
        },
        // 新增子节点
        handleSonCreate(data) {
            this.dialogTitle = '新建目录'
            this.catalogForm.parentId = data.catalogId;
            this.isShowCatalogDialog = true;
        },
        // 提交修改
        handleUpdate(data) {
            this.dialogTitle = '修改目录名称'
            this.catalogForm.catalogId = data.catalogId;
            this.catalogForm.catalogName = data.catalogName;
            this.isShowCatalogUpdateDialog = true;
        },
        //提交新增
        submitCatalog() {
            if (!this.catalogForm.catalogName) {
                this.$message.info("请输入名称")
                return;
            }
            createVideoCatalog(this.catalogForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.resetForm();
                    this.queryTreeCatalog();
                    this.isShowCatalogDialog = false;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        //提交修改
        submitUpdateCatalog() {
            if (!this.catalogForm.catalogName) {
                this.$message.info("请输入名称")
                return;
            }
            updateVideoCatalog(this.catalogForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.resetForm();
                    this.queryTreeCatalog();
                    this.isShowCatalogUpdateDialog = false;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        //提交删除
        handleDeleteCatalog(cId) {
            deleteVideoCatalog({catalogId: cId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryTreeCatalog();
                    this.queryVideoForm.catalogId = '';
                    this.queryVideoList();
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 查询树结构
        queryTreeCatalog() {
            treeVideoCatalog(this.queryCatalogForm).then(res => {
                if (res.data.code === 1) {
                    this.catalogList = res.data.data;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 重置表单
        resetForm() {
            this.catalogForm.catalogName = '';
        },
        // 查询视频列表
        queryVideoList() {
            this.loading = true;
            this.dataList = [];
            listVideo(this.queryVideoForm).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data || [];
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.$message.error("操作失败")
                }
            })
        },
        // 重置搜索
        resetSearch() {
            this.queryVideoForm.videoTitle = '';
            this.queryVideoForm.catalogId = '';
            this.queryVideoList();
        },
        // 播放视频
        handlePlay(item) {
            this.playUrl = item.videoUrl;
            this.isShowPlayDialog = true;
        },
        // 删除视频
        handleDeleteVideo(item) {
            deleteVideo({videoId: item.videoId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryVideoList();
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 上传视频
        handleVideoUpload(data) {
            this.resetVideoForm();
            this.videoForm.catalogId = data.catalogId;
            this.isShowVideoDialog = true;
        },
        beforeVideoUpload(rawFile) {
            if (!(rawFile.type === 'video/mp4' ||
              rawFile.type === 'video/x-flv' ||
              rawFile.type === 'video/x-ms-wmv')) {
                this.$message.error('文件必须是.mp4,.flv,.wmv格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 2048) {
                this.$message.error('文件大小不能超过2G')
                return false
            }
            let fs = rawFile.size / 1024 / 1024;
            this.partItemSize = this.calcShardSize(fs);
            return true
        },
        handleUploadRequest(option) {
            // 文件后缀
            var fileType = this.getFileName(option.file.name);
            // 获取文件名称，去掉后缀作为视频名称
            var obj = option.file.name;
            this.videoForm.videoTitle = obj.substring(0, obj.lastIndexOf("."));
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + fileType;
            this.loadingVisible = true;
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/schoolSafeVideo/${objName}`, option.file).then(res => {
                this.loadingVisible = false;
                // 上传成功之后，转换真实的地址
                signatureUrl(`/ygjy/schoolSafeVideo/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.videoForm.videoUrl = result;
                })
            })
        },
        handleVideoRemove(file, uploadFiles) {
            this.videoForm.videoUrl = '';
            this.videoForm.videoTitle = '';
        },
        async multipartUpload(ObjName, fileUrl) {
            try {
                let result = await client.multipartUpload(`${ObjName}`, fileUrl, {// 获取分片上传进度、断点和返回值。
                    progress: (p, cpt, res) => {
                        this.loadingPercentage = parseInt(p * 100);
                    },
                    timeout: 600000000,
                    // 设置并发上传的分片数量。
                    parallel: 6,
                    // 设置分片大小。默认值为1 MB，最小值为100 KB。
                    partSize: 1024 * 1024 * this.partItemSize,
                })
                // ObjName为文件名字,可以只写名字，就直接储存在 bucket 的根路径，如需放在文件夹下面直接在文件名前面加上文件夹名称
                return result
            } catch (e) {
                this.loadingVisible = false;
                if (client) client.cancel();
                this.$message.error('上传失败')
            }
        },
        calcShardSize(fileSize) {
            if (fileSize < 200) return SHARD_SIZE_CONFIG.SMALL;   // 1MB
            else if (fileSize < 1024) return SHARD_SIZE_CONFIG.MEDIUM; // 2MB
            else if (fileSize < 2048) return SHARD_SIZE_CONFIG.LARGE;  // 5MB
            else return Math.ceil(fileSize / SHARD_SIZE_CONFIG.X_LARGE_RATIO); // 动态分片
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));
        },
        // 提交视频
        submitVideo() {
            if (!this.videoForm.videoTitle) {
                this.$message.info("请输入视频名称")
                return;
            }
            if (!this.videoForm.videoUrl) {
                this.$message.info("请上传视频文件")
                return;
            }
            this.uploadLoading = true;
            createVideo(this.videoForm).then(res => {
                this.uploadLoading = false;
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryVideoList();
                    this.isShowVideoDialog = false;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 重置视频表单
        resetVideoForm() {
            this.videoFileList = [];
            this.uploadLoading = false;
            this.videoForm.videoTitle = '';
            this.videoForm.videoUrl = '';
            this.videoForm.videoCover = '';
            this.videoForm.videoSpeaker = '';
            this.videoForm.videoSpeakerOrg = '';
        },
    }
}
</script>
<style scoped>
.rqzj-manager-container{
    width: 100%;
    height: calc(100vh - 85px);
    overflow: hidden!important;
    box-sizing: border-box;
    display: flex;
}
.l-container{
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
}
.l-top-container{
    width: 100%;
    height: 50px;
    padding: 10px 0 10px 0;
    line-height: 28px;
    box-sizing: border-box;
    border-bottom: 1.5px solid #f1f1f1;
    display: flex;
}
.l-box{
    width: 50%;
    height: 100%;
    line-height: 28px;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
    padding-left: 10px;
    color: #242424;
}
.r-box{
    width: 50%;
    height: 100%;
    font-size: 15px;
    font-family: sans-serif;
    text-align: right;
    padding-right: 10px;
    color: #676767;
    display: flex;
    justify-content: flex-end;
}
.rqzj-l-tree-container{
    width: 100%;
    height: calc(100% - 60px)!important;
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: calc(100% - 24px);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.tree-l{
    width: calc(100% - 90px);
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号来表示溢出内容 */
}
.tree-r{
    width: 90px;
    display: flex;
}
.r-container{
    width: calc(100% - 270px);
    height: 100%;
    margin-left: 10px;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.video-card-container{
    height: calc(100vh - 165px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 10px;
    box-sizing: border-box;
}
.video-card{
    width: 200px;
    margin: 0 15px 15px 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
}
.video-card-cover{
    width: 100%;
    height: 150px; /* 高度固定，宽度拉伸填满 */
    object-fit: fill;
    display: block;
}
.video-card-del{
    display: none;
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 18px;
    color: red;
    background-color: #e4e7ed;
    z-index: 99;
}
.video-card:hover .video-card-del{
    display: block;
}
.video-card-name{
    padding: 8px 10px 0 10px;
    font-size: 14px;
    color: #242424;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.video-card-speaker{
    padding: 4px 10px 8px 10px;
    font-size: 12px;
    color: #909399;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.loading-overlay {
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>
